import Vue from 'vue';

import EditorialThreeColumn from './editorial-three-column/editorial-three-column.vue';
import EnhancedEditorialText from './enhanced-editorial-text/enhanced-editorial-text.vue';

Vue.component(EditorialThreeColumn.name, EditorialThreeColumn);
Vue.component(EnhancedEditorialText.name, EnhancedEditorialText);
